import React, { useState, useEffect } from "react";
import PdpButtonGroup from "../pdp-buttons-group";
import InfoIcon from "../../svg-icons/info";
import Heading from "../../elements/heading";
import PropTypes from "prop-types";
import classNames from "classnames";
import Checkbox from "../../elements/checkbox";
import "./style.scss";

const PdpOption = ({ id, reference, heading, buttons, checkboxes, enabled, info, isSubOption, onInfoClicked, onSelected, onCheckboxChecked }) => {
  const [buttonList, setButtonList] = useState(buttons);
  const [checkboxList, setCheckboxList] = useState(checkboxes);
  useEffect(() => {
    if (buttons) {
      let newButtons = [...buttons];
      newButtons.map(button => {
        let isDisabled = !enabled;
        if (button?.hasOwnProperty("usableStock")) {
          isDisabled = button?.usableStock > 0 ? !enabled : true;
        }
        button.isDisabled = isDisabled;
      });
      setButtonList(newButtons);
    }
    if (checkboxes) {
      let newCheckboxes = [...checkboxes];
      newCheckboxes.map(checkbox => {
        checkbox.disabled = !enabled;
      });
      setCheckboxList(newCheckboxes);
    }
  }, [buttons, checkboxes, enabled]);

  if (!buttons?.length && !checkboxes?.length) return <div />;
  return (
    <div className="pdp-option" id={"pdp-option-" + id} ref={reference}>
      <div className="heading-container">
        <Heading {...heading} typographyClass={isSubOption ? "type-h4" : "type-h3"} className={classNames({ disabled: !enabled })} />
        {info && (
          <span className={classNames("info-button", { disabled: !enabled })} onClick={onInfoClicked}>
            <InfoIcon />
          </span>
        )}
      </div>
      {buttonList && <PdpButtonGroup buttons={buttonList} onSelected={onSelected} />}
      {checkboxList && (
        <div className="checkbox-container">
          {checkboxList.map(checkbox => (
            <Checkbox {...checkbox} onChange={onCheckboxChecked} key={checkbox.id} />
          ))}
        </div>
      )}
    </div>
  );
};

PdpOption.propTypes = {
  id: PropTypes.string,
  reference: PropTypes.func,
  heading: PropTypes.object,
  buttons: PropTypes.array,
  enabled: PropTypes.bool,
  onInfoClicked: PropTypes.func,
  onSelected: PropTypes.func
};

export default PdpOption;
